import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSpacebar"><Path d="M3.5 13V18.5H20.5V13H22V20H2V13H3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
